var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 351.811,
    xmlns: "http://www.w3.org/2000/svg",
    height: 174.99,
    id: "screenshot-692702a0-d4f9-80b6-8003-fe91ed0818a8",
    viewBox: "0 0 351.811 174.99",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818a8",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818a9",
    clipPath: "url(#rumext-id-2-clip0_36_52)",
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rumext-id-2-clip0_36_52",
    className: "svg-def",
    transform: "matrix(0.667932, 0.000000, 0.000000, 0.641026, -0.092848, -0.001878)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 527,
    height: 273,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818aa"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818aa"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M43.238,174.990C41.577,174.990,39.915,174.384,38.650,173.171L1.898,137.920C0.682,136.753,0.000,135.171,0.000,133.519L0.000,97.486C0.000,94.052,2.903,91.260,6.487,91.260L51.755,91.260C55.335,91.260,58.242,94.047,58.242,97.486C58.242,100.924,55.339,103.708,51.755,103.708L12.974,103.708L12.974,130.939L47.823,164.364C50.358,166.795,50.358,170.735,47.823,173.162C46.562,174.388,44.900,174.990,43.238,174.990ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818ab"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818ab"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M51.759,138.401C50.097,138.401,48.436,137.794,47.170,136.580C44.635,134.149,44.635,130.210,47.170,127.781L84.101,92.364C86.632,89.932,90.739,89.932,93.274,92.364C95.805,94.796,95.805,98.735,93.274,101.162L56.348,136.580C55.074,137.794,53.416,138.401,51.759,138.401ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818ac"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818ac"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M76.605,148.805C74.948,148.805,73.282,148.199,72.020,146.985C69.485,144.553,69.485,140.614,72.020,138.187L96.165,115.024C98.700,112.593,102.807,112.593,105.338,115.024C107.874,117.456,107.874,121.392,105.338,123.823L81.194,146.989C79.924,148.203,78.263,148.805,76.605,148.805ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818ad"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818ad"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M27.247,84.865C24.259,84.865,21.572,82.868,20.915,79.955L7.651,21.042C6.895,17.682,9.120,14.373,12.619,13.645C16.126,12.920,19.572,15.054,20.335,18.410L33.595,77.323C34.351,80.683,32.126,83.996,28.627,84.720C28.166,84.818,27.704,84.865,27.247,84.865ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818ae"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818ae"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M84.399,17.404L87.779,2.837C87.898,2.308,88.534,2.023,89.008,2.308C94.017,5.265,97.361,10.586,97.361,16.656C97.361,25.118,90.873,32.112,82.402,33.333L71.894,79.958C71.232,82.868,68.546,84.869,65.558,84.869C65.100,84.869,64.639,84.822,64.178,84.720C60.675,83.996,58.462,80.683,59.213,77.323L69.767,30.518C65.203,27.475,62.202,22.393,62.202,16.660C62.202,8.245,68.615,1.279,77.005,0.010C77.597,-0.076,78.099,0.413,77.973,0.973L74.691,15.176C74.597,15.603,74.866,16.022,75.307,16.123L83.374,18.019C83.831,18.124,84.297,17.846,84.399,17.404ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818af"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818af"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M157.853,167.279L146.601,167.279L146.601,125.302C146.601,121.699,146.079,118.802,145.037,116.605C143.996,114.408,141.600,113.304,137.848,113.304L135.346,113.304L135.346,110.908L146.601,110.908C148.770,110.908,150.578,111.088,152.043,111.447C153.501,111.805,154.668,112.521,155.543,113.605C156.420,114.682,157.020,116.166,157.355,118.038C157.690,119.921,157.853,122.346,157.853,125.302L157.853,167.279ZZM157.102,98.314C157.102,99.994,156.579,101.306,155.543,102.274C154.497,103.237,153.105,103.715,151.349,103.715C149.434,103.715,147.785,102.955,146.410,101.431C145.033,99.912,144.347,98.119,144.347,96.035C144.347,94.360,144.870,93.036,145.912,92.085C146.952,91.121,148.348,90.639,150.100,90.639C152.015,90.639,153.664,91.399,155.040,92.915C156.420,94.434,157.102,96.235,157.102,98.314ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818b0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818b0"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M215.751,110.908L181.989,162.483L215.751,162.483L215.751,167.283L166.982,167.283L166.982,165.008L199.495,115.705L185.116,115.705C179.780,115.705,175.836,116.668,173.298,118.583C170.753,120.505,169.484,123.140,169.484,126.504L166.982,126.504L166.982,120.505C166.982,119.307,167.125,118.124,167.423,116.969C167.712,115.806,168.255,114.789,169.047,113.910C169.836,113.030,170.921,112.309,172.297,111.750C173.672,111.190,175.445,110.912,177.612,110.912L215.751,110.908ZL215.751,110.908ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818b1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818b1"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M235.009,115.700C236.593,114.181,238.757,112.810,241.509,111.569C244.261,110.328,247.515,109.701,251.262,109.701C253.928,109.701,256.532,110.003,259.084,110.606C261.619,111.208,263.893,112.329,265.898,113.965C267.894,115.603,269.502,117.819,270.707,120.622C271.920,123.422,272.523,126.978,272.523,131.293L272.523,167.280L261.272,167.280L261.272,131.293C261.272,128.336,260.872,125.819,260.080,123.735C259.296,121.664,258.248,119.976,256.961,118.699C255.667,117.422,254.209,116.506,252.585,115.943C250.955,115.390,249.270,115.105,247.519,115.105C245.016,115.105,242.701,115.744,240.578,117.027C238.451,118.305,236.597,119.785,235.013,121.460L235.013,167.283L223.758,167.283L223.758,102.512C223.758,98.910,223.235,96.012,222.190,93.815C221.149,91.618,218.756,90.514,215.005,90.514L212.502,90.514L212.502,88.117L223.758,88.117C225.925,88.117,227.734,88.297,229.195,88.658C230.657,89.018,231.825,89.735,232.698,90.815C233.576,91.900,234.177,93.376,234.511,95.256C234.846,97.135,235.013,99.555,235.013,102.512L235.009,115.700ZL235.009,115.700ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818b2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818b2"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M321.413,167.278L317.036,161.883L316.415,161.883C315.158,163.403,313.117,164.883,310.288,166.315C307.454,167.756,303.658,168.477,298.909,168.477C297.149,168.477,295.243,168.219,293.153,167.701C291.067,167.177,289.112,166.281,287.274,165.004C285.441,163.720,283.902,162.005,282.653,159.843C281.395,157.681,280.775,154.972,280.775,151.686C280.775,148.405,281.648,145.687,283.399,143.526C285.151,141.368,287.482,139.653,290.402,138.369C293.321,137.092,296.701,136.196,300.535,135.671C304.364,135.154,308.410,134.887,312.659,134.887L316.415,134.887C316.415,130.733,316.077,127.318,315.411,124.636C314.745,121.962,313.823,119.878,312.659,118.398C311.492,116.922,310.095,115.904,308.471,115.340C306.846,114.784,305.119,114.510,303.286,114.510C299.783,114.510,296.844,115.226,294.472,116.667C292.091,118.108,290.447,120.787,289.532,124.703L283.906,124.703C283.906,122.624,284.024,120.685,284.282,118.884C284.527,117.090,285.445,115.426,287.033,113.910C287.780,113.186,288.850,112.547,290.218,111.987C291.597,111.428,293.120,110.994,294.782,110.668C296.451,110.347,298.224,110.108,300.094,109.944C301.975,109.787,303.865,109.701,305.788,109.701C308.622,109.701,311.352,110.003,313.979,110.606C316.611,111.208,318.939,112.406,320.989,114.208C323.029,116.002,324.654,118.570,325.862,121.883C327.075,125.200,327.679,129.542,327.679,134.891L327.679,167.283L321.413,167.278ZL321.413,167.278ZZM316.415,139.696L312.659,139.696C306.405,139.696,301.506,140.792,297.966,142.990C294.427,145.186,292.656,148.092,292.656,151.686C292.656,153.608,292.982,155.281,293.655,156.726C294.321,158.159,295.198,159.365,296.288,160.321C297.371,161.280,298.619,161.976,300.036,162.424C301.457,162.858,302.951,163.073,304.539,163.073C307.617,163.073,310.059,162.337,311.855,160.857C313.643,159.376,315.166,157.724,316.419,155.884L316.415,139.696ZL316.415,139.696ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818b3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818b3"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M351.807,167.280L340.547,167.280L340.547,102.512C340.547,98.910,340.025,96.012,338.983,93.815C337.943,91.618,335.550,90.514,331.794,90.514L329.296,90.514L329.296,88.117L340.547,88.117C342.716,88.117,344.528,88.297,345.993,88.658C347.451,89.018,348.618,89.735,349.493,90.815C350.370,91.900,350.974,93.376,351.309,95.256C351.636,97.135,351.811,99.555,351.811,102.512L351.807,167.280ZL351.807,167.280ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818b4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818b4"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M339.045,63.350C340.764,63.722,342.557,63.749,344.401,63.397C346.254,63.041,347.847,62.410,349.219,61.474C350.583,60.546,351.444,59.446,351.807,58.169C351.260,58.400,350.509,58.639,349.533,58.862C348.565,59.097,347.598,59.172,346.626,59.086C345.659,58.996,344.838,58.714,344.177,58.205C343.503,57.715,343.177,56.854,343.177,55.640L343.177,6.622L332.917,8.795L332.917,55.640C332.917,57.911,333.501,59.669,334.689,60.914C335.869,62.163,337.318,62.970,339.045,63.350ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818b5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818b5"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M311.010,38.442L311.010,66.690C311.010,72.353,306.233,76.918,300.347,76.918L299.931,76.918C298.717,76.864,297.571,76.628,296.496,76.233C296.496,76.233,298.995,80.215,304.360,80.713C304.718,80.736,305.074,80.767,305.458,80.767C307.410,80.767,309.283,80.423,311.010,79.792C317.007,77.655,321.265,72.117,321.265,65.609L321.265,36.292L311.010,38.442ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818b6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818b6"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M316.138,32.310C318.963,32.310,321.250,30.117,321.250,27.415C321.250,24.709,318.963,22.520,316.138,22.520C313.317,22.520,311.034,24.713,311.034,27.415C311.034,30.117,313.321,32.310,316.138,32.310ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818b7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818b7"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M344.320,76.805C343.675,76.805,343.046,76.695,342.437,76.484C341.821,76.272,341.327,75.947,340.935,75.509C340.539,75.071,340.343,74.490,340.343,73.774C340.343,72.799,340.678,72.035,341.335,71.480C342.000,70.928,342.756,70.649,343.601,70.649C344.520,70.649,345.365,70.817,346.148,71.162C346.929,71.507,347.537,71.871,347.982,72.263C347.843,71.413,347.525,70.614,347.014,69.866C346.504,69.118,345.786,68.503,344.846,68.033C343.912,67.564,342.732,67.321,341.307,67.321C339.918,67.321,338.693,67.705,337.645,68.472C336.591,69.236,335.767,70.297,335.170,71.648C334.578,73.003,334.281,74.557,334.281,76.315L334.281,76.805L331.330,76.805L327.872,82.322L348.337,82.322L351.803,76.805L346.353,76.805L344.320,76.805ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-692702a0-d4f9-80b6-8003-fe91ed0818b8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-692702a0-d4f9-80b6-8003-fe91ed0818b8"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M278.496,22.516C268.273,22.516,259.721,29.298,257.468,38.442L268.322,38.442C270.168,34.863,274.042,32.384,278.496,32.384C284.763,32.384,289.850,37.263,289.850,43.274C289.850,49.285,284.763,54.164,278.496,54.164L272.806,54.164C272.829,54.007,272.829,53.819,272.829,53.658C272.829,47.914,267.964,43.274,262.003,43.274C256.038,43.274,251.172,47.910,251.172,53.658C251.172,53.819,251.172,54.007,251.196,54.164L174.325,54.164L174.325,6.618L164.042,8.807L164.042,63.409C164.042,70.214,158.298,75.724,151.231,75.724C144.139,75.724,138.391,70.214,138.391,63.409C138.391,61.435,138.886,59.536,139.767,57.872C139.767,57.903,139.796,57.903,139.796,57.927C139.849,57.794,139.906,57.637,139.959,57.504C139.988,57.504,139.988,57.449,140.016,57.449C140.126,57.214,140.265,56.999,140.428,56.791C140.428,56.768,140.428,56.768,140.457,56.768C141.282,55.683,142.629,54.974,144.139,54.974C145.655,54.974,147.001,55.683,147.822,56.768C148.018,56.317,148.099,55.840,148.099,55.311C148.099,53.999,147.467,52.781,146.475,51.990C145.924,51.540,145.295,51.227,144.580,51.039C145.984,50.299,146.973,48.854,146.973,47.190C146.973,46.453,146.781,45.768,146.450,45.189C143.699,46.422,141.306,48.298,139.441,50.592C136.860,53.764,135.346,57.719,135.346,62.070C135.346,72.380,144.062,80.764,154.836,80.764C158.163,80.764,161.298,79.949,164.046,78.524C169.599,75.677,173.529,70.297,174.220,64.020L278.496,64.020C290.459,64.020,300.134,54.739,300.134,43.270C300.134,31.804,290.459,22.516,278.496,22.516ZZM264.697,54.160C264.444,55.370,263.322,56.290,262.003,56.290C260.676,56.290,259.554,55.370,259.309,54.160C259.276,54.003,259.252,53.846,259.252,53.655C259.252,52.186,260.488,51.023,262.003,51.023C263.509,51.023,264.746,52.186,264.746,53.655C264.750,53.846,264.727,54.003,264.697,54.160ZZ",
    style: {
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.258a533c9221c18b635eb8397421a785.svg";
export { ForwardRef as ReactComponent };